<template>
  <!-- I think that adding new readings becomes too complex when a meter reconfig is involved and
  the way honecomb creates new electricity readings needs to be altered further from gas to allow
  for more readable code. See Note in the <script> tag for more details-->
  <div class="container-fluid">
    <div class="amr_ls h-100 bg-white">
      <!-- Display MPAN and Serial -->
      <div class="row" v-if="activeMeter">
        <div class="col-lg-6">
          <p class="font-weight-bold d-inline">MPAN:</p>
          <p class="d-inline ml-2">{{ activeMeter.Mpan }}</p>
        </div>
        <div class="col-lg-6">
          <p class="font-weight-bold d-inline">Serial Number:</p>
          <p class="d-inline ml-2">{{ activeMeter.Serial }}</p>
        </div>
      </div>

      <!-- Choose a reading date and type -->
      <div class="row">
        <div class="col-lg-6 mt-3">
          <p class="font-weight-bold d-inline">Reading Date:</p>
          <div class="form-group">
            <div>
              <el-date-picker
                v-model="pickerDate"
                format="dd.MM.yyyy"
                value-format="yyyy-MM-dd"
                class="float-right"
                type="date"
                placeholder="Select an end date"
                :picker-options="pickerOptions"
                @change="onDateChange"
              ></el-date-picker>
            </div>
          </div>
        </div>
        <div class="col-lg-6 no-pad-lg mt-3">
          <p class="font-weight-bold d-inline">Reading Type:</p>
          <div class="btn-group d-block w-100">
            <div class="form-group">
              <select
                v-model="type"
                class="form-control"
                name="selection"
                required
                :disabled="hasMeterRegistersChanged"
              >
                <option value="Actual">Actual CoS Read</option>
                <option value="Customer">Customer</option>
                <option value="Deemed">Deemed</option>
                <option value="Final">Final</option>
                <option value="Initial">Initial</option>
                <option value="Manual">Manual</option>
                <option value="OldSupplier">Old Supplier</option>
                <option value="Ppmip">PPMIP</option>
                <option value="Modified">Modified</option>
                <option value="Routine">Routine</option>
                <option value="Special">Special</option>
                <option value="ProvingTest">Proving Test</option>
                <option value="ChangeOfTenancy">Change of Tenancy</option>
                <option value="ManualEstimate">Manual Estimate</option>
                <option
                  v-if="hasMeterRegistersChanged"
                  value="FinalAndInitial"
                ></option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- Enter the reading set and view the previous reading set for reference -->
      <div class="row">
        <div class="col-xl-6 mt-3">
          <p class="font-weight-bold d-inline">New Reading Set:</p>
          <!-- isNewConfig will be equal to the index, this means that if there is a second meterConfig it
          will be recognised as a new config that didn't exits before and requires an initial reading.
          !isNewConfig means that the meterConfig already existed before selected date-->
          <div
            class="pb-3"
            v-for="(meterConfig, isNewConfig) in activeMeterConfigs"
            :key="isNewConfig"
          >
            <h6 class="pl-4" v-if="!isNewConfig && currentRegisters.length > 1">
              Final Reading:
            </h6>
            <div v-else-if="currentRegisters.length > 1">
              <hr />
              <h6 class="pl-4">
                Initial Reading:
                <p class="d-inline px-1">Edit</p>
                <label
                  class="form-check-label radio_style"
                  for="allowManualReadingInput"
                >
                  <input
                    type="checkbox"
                    class="form-check-input radio_style"
                    id="allowManualReadingInput"
                    v-model="allowManualReadingInput"
                  />
                  <span class="default"></span>
                </label>
              </h6>
            </div>

            <div
              class="mrs mt-2"
              v-for="(register, index) in reading"
              :key="index"
            >
              <!-- Don't change == to ===, as isFromNewMeterConfig is a bool and isNewConfig is either a 1 or 0.
              Using === would work with !!isNewConfig-->
              <div v-if="register.isFromNewMeterConfig == isNewConfig">
                <!-- icon and heading -->
                <div class="d-flex justify-content-center mt-2">
                  <i
                    class="my-auto mr-2"
                    :class="{
                      'fas fa-sun': register.BillingTypeId == 'Day',
                      'fas fa-moon': register.BillingTypeId == 'Night',
                      'fas fa-couch': register.BillingTypeId == 'Weekend',
                      'fas fa-unlock-alt':
                        register.BillingTypeId == 'Unrestricted',
                    }"
                  ></i>
                  <span
                    >{{ register.BillingTypeId }} ({{
                      register.MeterRegisterId
                    }})</span
                  >
                </div>
                <!-- enter readings input -->
                <div
                  class="d-flex justify-content-center ml-2"
                  v-if="activeMeter && !disableManualReading(register)"
                >
                  <input
                    v-for="(digit, i) in register.Digits"
                    :key="i"
                    class="
                      form-control form-control-lg
                      font-weight-bold
                      at_input
                      mr-2
                    "
                    required
                    type="text"
                    pattern="\d*"
                    :ref="'elec' + index"
                    maxlength="1"
                    v-model="register.Reading[i]"
                    @keypress="autotab($event, i, register.Digits, index)"
                    @keydown.delete="reverseAutotab($event, i, index)"
                    @paste="
                      onPaste($event, register.Digits, 'elec' + index, index)
                    "
                  />
                </div>
                <div
                  class="d-flex justify-content-center ml-2"
                  v-else-if="activeMeter"
                >
                  <input
                    v-for="(digit, i) in register.Digits"
                    :key="i"
                    class="
                      form-control form-control-lg
                      font-weight-bold
                      at_input
                      mr-2
                    "
                    type="text"
                    pattern="\d*"
                    :ref="'elec' + index"
                    maxlength="1"
                    :value="getOldRegister(register).Reading[i]"
                    disabled
                  />
                  <!-- <p class="d-inline">Edit</p>
              <label class="form-check-label radio_style" for="acceptingMeterReading">
                <input
                  type="checkbox"
                  class="form-check-input radio_style"
                  id="overrideDisableReading"
                />
                <span class="default"></span>
                  </label>-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right section for displaying reading info and readings -->
        <!-- last reading info -->
        <div class="col-xl-6 mt-3" v-if="activeMeter.LatestReading">
          <p class="font-weight-bold d-inline">Latest Reading Set:</p>
          <div class="d-inline my-auto">
            <span class="ml-2" v-if="activeMeter.LatestReading.ReadingDate">{{
              activeMeter.LatestReading.ReadingDate | shortDate
            }}</span>
            <span
              v-if="diff(activeMeter.LatestReading.ReadingDate) > 25"
              class="text-danger font-weight-bold ml-1"
              >({{
                diff(activeMeter.LatestReading.ReadingDate) | suffix
              }})</span
            >
            <span
              v-else-if="diff(activeMeter.LatestReading.ReadingDate) <= 25"
              class="text-success font-weight-bold ml-1"
              >({{
                diff(activeMeter.LatestReading.ReadingDate) | suffix
              }})</span
            >
          </div>
          <div class="d-inline my-auto">
            <span>
              -
              {{ activeMeter.LatestReading.ReadingType | splitString }}
            </span>
          </div>
          <!-- current readings section -->
          <div
            class="mrs mt-2"
            v-for="(registerReading, index) in latestReadingSet"
            :key="index"
          >
            <div
              v-if="
                findRegister(
                  activeMeter.Config,
                  registerReading.MeterRegisterId
                ).IsSettlement &&
                findRegister(
                  activeMeter.Config,
                  registerReading.MeterRegisterId
                ).BillingTypeId != 'NotApplicable'
              "
            >
              <!-- icon and heading -->
              <div class="d-flex justify-content-center mt-2">
                <i
                  class="my-auto mr-2"
                  :class="{
                    'fas fa-sun':
                      findRegister(
                        activeMeter.Config,
                        registerReading.MeterRegisterId
                      ).BillingTypeId == 'Day',
                    'fas fa-moon':
                      findRegister(
                        activeMeter.Config,
                        registerReading.MeterRegisterId
                      ).BillingTypeId == 'Night',
                    'fas fa-couch':
                      findRegister(
                        activeMeter.Config,
                        registerReading.MeterRegisterId
                      ).BillingTypeId == 'Weekend',
                    'fas fa-unlock-alt':
                      findRegister(
                        activeMeter.Config,
                        registerReading.MeterRegisterId
                      ).BillingTypeId == 'Unrestricted',
                  }"
                ></i>
                <span
                  >{{
                    findRegister(
                      activeMeter.Config,
                      registerReading.MeterRegisterId
                    ).BillingTypeId
                  }}
                  ({{ registerReading.MeterRegisterId }})</span
                >
              </div>
              <!-- readings -->
              <div class="d-flex justify-content-center ml-2">
                <input
                  v-for="(digit, index) in splitReading(
                    registerReading,
                    activeMeter.Config
                  )"
                  :key="index"
                  class="
                    form-control form-control-lg
                    font-weight-bold
                    at_input
                    mr-2
                  "
                  type="text"
                  maxlength="1"
                  readonly
                  :value="digit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Displays when the reading set isn't validated with the option to override and submit anyway -->
      <div
        v-if="!isValid && fullyPopulated && validationAttempted"
        class="row"
      >
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-2 my-auto text-center">
              <img
                src="@/assets/img/warning_icon.png"
                class="d-inline"
                alt="Danger"
              />
            </div>
            <div class="col-10 my-auto">
              <p class="d-inline">
                This isn't consistent with a value we'd expect for:
              </p>
              <p class="d-inline ml-2">{{ date | shortDate }}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isValid && fullyPopulated && validationAttempted"
        class="row"
      >
        <div class="col-12 mt-3">
          <div class="row">
            <div class="col-10 offset-2">
              <p class="d-inline">Submit anyway</p>
              <div class="d-inline">
                <span class="d-inline ml-2">
                  <label
                    class="form-check-label radio_style"
                    for="acceptingMeterReading"
                  >
                    <input
                      type="checkbox"
                      class="form-check-input radio_style"
                      id="acceptingMeterReading"
                      name="optradio"
                      v-model="override"
                    />
                    <span class="default"></span>
                  </label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Button to submit the reading set -->
      <div class="row">
        <div class="col-12 text-center">
          <button
            type="submit"
            class="btn btn-hc mt-4"
            @click="submitReading"
            :disabled="submitStatus === 'PENDING'"
          >
            Submit Reading Set
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Vue from "vue";

// Mixins
import _filters from "@/mixins/filters.js";
import snotifyHttpError from "@/mixins/snotifyHttpResponses";

export default {
  // NOTE: This was build from gas code so treats each register as a seperate reading, this should be updated in the future to be
  // more inline with the logic of adding an electricity reading. Most of this component is fine though, it's just the handeling of
  // reading objects. If wondering why there is a validateReadings(), validateReading() and sendValidateReading(), this is why.
  // Also the api calls to readingsbot neef to be moved into Vuex for consistency.
  name: "add-electricity-reading",
  mixins: [_filters, snotifyHttpError],
  data() {
    return {
      submitStatus: null,
      type: "Customer",
      pickerDate: moment().format("YYYY-MM-DD"),
      pickerOptions: {
        disabledDate(date) {
          return date > moment();
        },
      },
      allowManualReadingInput: false,
      validationAttempted: false,
      userSelectedType: "Customer",
      previousIsChangeDate: false,
    };
  },
  validations: {
    type: {
      required,
    },
    date: {
      required,
    },
  },
  mounted() {
    // Creates a reading object on mounted. This should be changed to create reading object when register is loaded in Vuex.
    this.setReading();
  },
  methods: {
    setReading() {      
      // NOTE: This method needs refactoring.
      let that = this;
      let reading = [];
      // This property is to differentiate between readings on the newest meter config and the old meter config on day where there is a config change
      let isFromNewMeterConfig = false; // true if register is on the new config

      // Loop through each meter config
      this.activeMeterConfigs.forEach((meterConfig) => {
        let configRegisters = [];
        // Loop through each register
        meterConfig.Registers.forEach((register) => {
          // When BillingTypeId is equal to "NotApplicable" it means that the register still exists exept it is not being uses, so Honeycomb should ignore it when createing a reading object.
          // Also filter out Non-Settlement registers as they are not used for billing purposes
          if (register.IsSettlement && register.BillingTypeId !== "NotApplicable") {
            // isOnOldMeterConfig is true when the register already existed on old meter config. (I think)
            // NOTE: It's not clear how this is working/being used, will need to be clarified.
            let isOnOldMeterConfig =
              this.$_.filter(
                that.currentRegisters[0],
                function (activeRegister) {
                  return register.RegisterId == activeRegister.RegisterId;
                }
              ).length > 0;

            configRegisters.push({
              MeterRegisterId: register.RegisterId,
              BillingTypeId: register.BillingTypeId,
              Digits: register.Digits,
              IsValid: false,
              Reading: [],
              // Below props are for use on meter re-configs where registers may or may not have a changed BillingTypeId.
              isFromNewMeterConfig: isFromNewMeterConfig,
              isOnOldMeterConfig: isOnOldMeterConfig,
            });
          }
        });
        reading = reading.concat(
          configRegisters.sort(
            (a, b) => this.order.indexOf(a.BillingTypeId) - this.order.indexOf(b.BillingTypeId)
          )
        );
        // For all following loop iterations register will set to new.
        isFromNewMeterConfig = true;
      });

      this.reading = reading.sort((a, b) => {
        return (
          this.order.indexOf(a.BillingTypeId) -
            this.order.indexOf(b.BillingTypeId) ||
          (a.MeterRegisterId > b.MeterRegisterId ? 1 : -1)
        );
      });

      // Field preservation logic for type selection
      if (this.isChangeDate) {
        this.type = "FinalAndInitial";
      } else if (this.previousIsChangeDate && this.userSelectedType) {
        // Restore user selection when transitioning from change date
        this.type = this.userSelectedType;
      } else if (!this.previousIsChangeDate) {
        // Keep user selection or default
        this.type = this.userSelectedType || "Customer";
      }

      // Track change date state
      this.previousIsChangeDate = this.isChangeDate;
    },

    onDateChange() {
      // Store previous config before date change
      const previousConfigs = [...this.activeMeterConfigs];
      
      // Allow Vue to update computed properties
      this.$nextTick(() => {
        const newConfigs = this.activeMeterConfigs;
        
        // Only rebuild if configs actually changed
        if (!this.configsAreEqual(previousConfigs, newConfigs)) {
          this.setReading();
        } else {
          // Still need to update preservation state even if not rebuilding
          if (this.isChangeDate) {
            this.type = "FinalAndInitial";
          } else if (this.previousIsChangeDate && this.userSelectedType) {
            this.type = this.userSelectedType;
          }
          this.previousIsChangeDate = this.isChangeDate;
        }
      });
    },

    configsAreEqual(configs1, configs2) {
      if (configs1.length !== configs2.length) {
        return false;
      }
      
      return configs1.every((config1, index) => {
        const config2 = configs2[index];
        if (!config2) return false;
        
        // Compare SharedId (unique identifier for each config)
        if (config1.SharedId !== config2.SharedId) {
          return false;
        }
        
        // Compare register structure
        if (config1.Registers.length !== config2.Registers.length) {
          return false;
        }
        
        return config1.Registers.every((reg1, regIndex) => {
          const reg2 = config2.Registers[regIndex];
          return reg1.RegisterId === reg2.RegisterId &&
                 reg1.BillingTypeId === reg2.BillingTypeId &&
                 reg1.Digits === reg2.Digits;
        });
      });
    },

    validateReading() {
      // Track user selection for preservation (only when type is not forced to FinalAndInitial)
      if (this.type !== 'FinalAndInitial') {
        this.userSelectedType = this.type
      }
      
      this.submitStatus = "VALIDATING";
      this.isValid = false;
      if (this.fullyPopulated) {
        // This code only runs when a whole reading has been entered
        if (this.hasMeterRegistersChanged) {
          // This is an unsuccesfull attempt to stop it double submitting vaildation when fatfingering keypresses
          this.validateReadings();
        } else {
          this.sendValidateReading(this.registerReadings, this.type).then(
            (isValid) => {
              this.isValid = isValid;
              this.validationAttempted = true;
              if (isValid) {
                // If validation passes, proceed with submission
                this.proceedWithSubmission();
              }
            }
          );
        }
      }
    },

    validateReadings() {
      let splitReadingsByMeterConfig = this.$_.chunk(
        this.registerReadings,
        this.$_.where(this.reading, { isFromNewMeterConfig: false }).length
      );

      Promise.all([
        this.sendValidateReading(
          splitReadingsByMeterConfig[0],
          "Final",
          this.activeMeterConfigs[0].SharedId
        ),
        this.sendValidateReading(
          splitReadingsByMeterConfig[1],
          "Initial",
          this.activeMeterConfigs[1].SharedId
        ),
      ]).then((isValid) => {
        this.isValid = isValid[0] && isValid[1];
        this.validationAttempted = true;
        if (this.isValid) {
          // If validation passes, proceed with submission
          this.proceedWithSubmission();
        }
      });
    },

    sendValidateReading(registerReadings, type, meterConfigSharedId) {
      // NOTE: This could be more readable.
      return new Promise((res) => {
        this.$http
          .post(
            "https://" +
              Vue.config.honeycomb.readingsbot.electricity.domain +
              "/api/v1/readings/validate",
            {
              ReadingDate: this.date,
              RegisterReadings: registerReadings,
              Mpan: this.activeMeter.Mpan,
              Serial: this.activeMeter.Serial,
              ReadingType: type,
              MeterConfigSharedId: meterConfigSharedId,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.submitStatus = "OK";
            if (response.data.hasOwnProperty("IsValid")) {
              this.override = false;
              if (response.data.IsValid) {
                res(true);
              } else {
                res(false);
              }
            }
          })
          .catch((error) => {
            // Error
            this.submitStatus = "Error";
            this.override = false;
            res(false);
            this.snotifyHttpError(error);
          });
      });
    },

    submitReading() {
      // Collect all validation warnings
      let warnings = [];
      
      if (!this.fullyPopulated) {
        warnings.push("Reading not provided.");
      }
      if (!this.isValid && this.validationAttempted && !this.override) {
        warnings.push("Submit anyway not selected.");
      }
      
      // If there are warnings, show them all at once
      if (warnings.length > 0) {
        this.$snotify.warning(warnings.join('\n\n'));
        return;
      }
      
      // If validation hasn't been attempted yet, validate first
      if (!this.validationAttempted) {
        this.validateReading();
        return;
      }
      
      // Proceed with submission
      this.proceedWithSubmission();
    },

    proceedWithSubmission() {
      if (this.hasMeterRegistersChanged) {
        this.submitReadings();
      } else {
        this.submit(this.registerReadings, this.type);
      }
    },

    submitReadings() {
      let splitReadingsByMeterConfig = this.$_.chunk(
        this.registerReadings,
        this.$_.where(this.reading, { isFromNewMeterConfig: false }).length
      );
      this.submit(
        splitReadingsByMeterConfig[0],
        "Final",
        this.activeMeterConfigs[0].SharedId
      );
      this.submit(
        splitReadingsByMeterConfig[1],
        "Initial",
        this.activeMeterConfigs[1].SharedId
      );
    },

    submit(registerReadings, type, meterConfigSharedId) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";
        this.$snotify.async(
          "Adding reading set...",
          () =>
            new Promise((resolve, reject) => {
              this.$http
                .post(
                  "https://" +
                    Vue.config.honeycomb.readingsbot.electricity.domain +
                    "/api/v1/readings",
                  {
                    Mpan: this.activeMeter.Mpan,
                    Serial: this.activeMeter.Serial,
                    ReadingDate: this.date,
                    ReadingType: type,
                    RegisterReadings: registerReadings,
                    OverrideTolerances: this.override,
                    IsChangeOfTenancy: false,
                    MeterConfigSharedId: meterConfigSharedId,
                  },
                  {
                    withCredentials: true,
                  }
                )
                .then(() => {
                  this.submitStatus = "OK";
                  resolve({
                    body: "Success! Reading set added!",
                    config: {
                      closeOnClick: true,
                      timeout: 2000,
                    },
                  });
                  this.isValid = true;
                  this.override = false;
                  this.pickerDate = moment().format("YYYY-MM-DD");
                  this.type = "Customer";
                  this.reading.forEach((rr) => {
                    rr.Reading = [];
                  });
                  this.$store.dispatch("refreshReadings");
                  this.$store.dispatch("refreshLatestReading");
                  this.$store.dispatch("refreshServiceList");
                })
                .catch((error) => {
                  // Error
                  this.submitStatus = "Error";
                  reject(this.snotifyHttpError(error));
                });
            })
        );
      }
    },
    disableManualReading(register) {
      // When a register is being carried over from the
      // old config to the new config by default Honeycomb
      // will carry over the closing reading of the old meter config.
      return (
        register.isFromNewMeterConfig &&
        register.isOnOldMeterConfig &&
        !this.allowManualReadingInput
      );
    },
    findRegisteredId(billingType) {
      let register = this.$_.findWhere(this.currentRegisters, {
        BillingTypeId: billingType,
      });
      if (register) {
        return register.RegisterId;
      } else {
        return null;
      }
    },
    getOldRegister(register) {
      return this.$_.find(this.reading, (reading) => {
        return reading.MeterRegisterId == register.MeterRegisterId;
      });
    },
    findRegister(config, meterRegisterId) {
      return this.$_.findWhere(config.Registers, {
        RegisterId: meterRegisterId,
      });
    },
    splitReading(registerReading, config) {
      let maxDigits = this.findRegister(
        config,
        registerReading.MeterRegisterId
      ).Digits;
      let parsedReading = registerReading.Reading.toString().split(".")[0];
      return parsedReading.padStart(maxDigits, "0").split("").map(Number);
    },
    hasBillingType(billingType) {
      let register = this.$_.findWhere(this.currentRegisters, {
        BillingTypeId: billingType,
      });

      if (register) {
        return true;
      } else {
        return false;
      }
    },
    isUnrestrictedSettlement() {
      let register = this.$_.findWhere(this.currentRegisters, {
        BillingTypeId: "Unrestricted",
      });

      if (register.IsSettlement) {
        return register.IsSettlement;
      } else {
        return false;
      }
    },
    formatItem(item) {
      return item.split(/(?=[A-Z])/).join(" ");
    },

    diff: function (readingDate) {
      return moment().diff(readingDate, "days");
    },
    onPaste(e, digits, ref, rrIndex) {
      var pastedData = e.clipboardData
        .getData("Text")
        .replace(/[^0-9]+/g, "")
        .trim()
        .padStart(digits, "0")
        .split("")
        .map(Number);
      window.setTimeout(() => {
        // Do something immediately after the paste
        this.reading[rrIndex].Reading = [];

        for (let index = 0; index < digits; index++) {
          this.reading[rrIndex].Reading[index] = pastedData[index];
        }

        this.$refs[ref][digits - 1].focus();
      });
    },

    autotab($event, index, digits, rrIndex) {
      var keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode > 47 && keyCode < 58) {
        if (this.reading[rrIndex].Reading.length < digits) {
          if (
            this.reading[rrIndex].Reading[index] != undefined ||
            this.reading[rrIndex].Reading[index] != ""
          ) {
            this.reading[rrIndex].Reading.push($event.key);
          }
        }
        return $event.target.nextElementSibling.focus();
      }
      return $event.preventDefault();
    },

    reverseAutotab($event, index, rrIndex) {
      $event.preventDefault();
      this.reading[rrIndex].Reading.splice(index, 1);
      return $event.target.previousElementSibling.focus();
    },

    currentMeters(meters) {
      let that = this;
      return this.$_.sortBy(
        that.$_.filter(meters, function (meter) {
          return !that.$_.has(meter, "Removed");
        }),
        "Installed"
      ).reverse();
    },

    currentConfig(meter) {
      if (meter)
        if (meter.MeterConfigs.length == 1) {
          return meter.MeterConfigs[0];
        }
      return this.$_.filter(meter.MeterConfigs, function (config) {
        return (
          moment(moment.utc().format("YYYY-MM-DD")).isSameOrAfter(
            config.EffectiveFrom
          ) &&
          (!config.hasOwnProperty("EffectiveTo") ||
            config.EffectiveTo == null ||
            moment(moment.utc().format("YYYY-MM-DD")).isSameOrBefore(
              config.EffectiveTo
            ))
        );
      });
    },
  },
  computed: {
    order() {
      return ["Unrestricted", "Day", "Night", "EveWeekend"];
    },
    isChangeDate() {
      return this.hasMeterChanged || this.hasMeterConfigChanged;
    },
    hasMeterChanged() {
      if (!this.activeMeter || !this.activeMeter.Installed || !this.pickerDate) return false;
      return moment(this.pickerDate).isSame(this.activeMeter.Installed, 'day');
    },
    hasMeterConfigChanged() {
      if (!this.activeMeter || !this.activeMeter.MeterConfigs || !this.pickerDate) return false;
      
      // Check if the selected date falls on any meter config change dates
      const changeDate = moment(this.pickerDate);
      return this.activeMeter.MeterConfigs.some(config => 
        changeDate.isSame(config.EffectiveFrom, 'day')
      );
    },
    activeMeterConfigs() {
      if (!this.activeMeter || !this.activeMeter.MeterConfigs || !this.pickerDate) return [];
      
      let that = this;
      return this.$_.sortBy(
        this.$_.filter(this.activeMeter.MeterConfigs, function (meterConfig) {
          const effectiveFrom = moment(meterConfig.EffectiveFrom);
          const effectiveTo = meterConfig.EffectiveTo ? moment(meterConfig.EffectiveTo) : null;
          const pickerDate = moment(that.pickerDate);
          
          return effectiveFrom.isSameOrBefore(pickerDate, "day") &&
            (!effectiveTo || effectiveTo.isSameOrAfter(pickerDate, "day"));
        }),
        "EffectiveFrom"
      );
    },
    date() {
      return moment.utc(this.pickerDate).format();
    },
    reading: {
      get() {
        return this.$store.state.meters.reading;
      },
      set(reading) {
        this.$store.commit("updateReading", reading);
      },
    },
    isValid: {
      get() {
        return this.$store.state.meters.isValid;
      },
      set(bool) {
        this.$store.commit("updateIsValid", bool);
      },
    },
    override: {
      get() {
        return this.$store.state.meters.override;
      },
      set(bool) {
        this.$store.commit("updateOverride", bool);
      },
    },
    activeMeter() {
      return this.$store.state.meters.activeMeter;
    },
    registerReadings() {
      var registerReadings = [];
      if (this.reading) {
        this.reading.forEach((rr) => {
          if (
            (rr.Reading.length > 0) |
            (this.getOldRegister(rr).Reading.length > 0 &&
              !this.allowManualReadingInput)
          ) {
            var r = rr.Reading.toString();
            if (
              rr.isFromNewMeterConfig &&
              rr.isOnOldMeterConfig &&
              !this.allowManualReadingInput
            )
              r = this.getOldRegister(rr).Reading.toString();
            r = +parseFloat(r.replace(/,/g, "")).toFixed(2);

            registerReadings.push({
              Reading: r,
              MeterRegisterId: rr.MeterRegisterId,
              IsValid: rr.IsValid,
            });
          }
        });
      }
      return registerReadings;
    },
    fullyPopulated() {
      // This is currently using the same property as gas which uses an int
      // Note: This code needs to use a electricity specific
      if (Array.isArray(this.reading)) {
        let count = 0;
        this.reading.forEach((rr) => {
          if (rr.Reading.length == rr.Digits) {
            count++;
          } else if (
            rr.isFromNewMeterConfig &&
            rr.isOnOldMeterConfig &&
            !this.allowManualReadingInput
          ) {
            if (this.getOldRegister(rr).Reading.length == rr.Digits) {
              count++;
            }
          }
        });

        return count == this.reading.length;
      } else {
        return false;
      }
    },
    isMeterConfigChangeDate() {
      return this.activeMeterConfigs.length > 1;
    },
    currentRegisters() {
      // Will return an array of all of the registers that are active on selected date
      let registers = [];
      this.activeMeterConfigs.forEach((meterConfig) => {
        registers.push(
          this.$_.map(
            this.$_.filter(meterConfig.Registers, (register) => register.IsSettlement),
            function (register) {
              return {
                RegisterId: register.RegisterId,
                BillingTypeId: register.BillingTypeId,
                Tpr: register.Tpr,
              };
            }
          )
        );
      });
      return registers;
    },
    hasMeterRegistersChanged() {
      if (this.isMeterConfigChangeDate) {
        return this.currentRegisters[0] != this.currentRegisters[1];
      } else return false;
    },

    latestReadingSet() {
      const findRegister = ({ MeterRegisterId }) =>
        this.findRegister(this.activeMeter.Config, MeterRegisterId);

      let readings = [...this.activeMeter.LatestReading.RegisterReadings];

      readings = readings.map((r) => {
        let { BillingTypeId } = findRegister(r);
        return { ...r, BillingTypeId };
      });

      return readings.sort((a, b) => {
        return (
          this.order.indexOf(a.BillingTypeId) -
            this.order.indexOf(b.BillingTypeId) ||
          (a.MeterRegisterId > b.MeterRegisterId ? 1 : -1)
        );
      });
    },
  },
  watch: {
    activeMeter() {
      this.setReading();
    },
    reading: {
      handler() {
        // Reset validation state when any reading changes
        if (this.validationAttempted) {
          this.validationAttempted = false;
          this.submitStatus = "";
        }
      },
      deep: true
    }
  },
};
</script>